import { Check, Wifi, WifiOff } from "lucide-react";
import "./NetworkInfo.css";
import useNetworkInfo from "../../hooks/useNetworkInfo";
import React from "react";

const NETWORK_ONLINE_NOTICE_TIMEOUT = 3500;

export function NetworkInfo({ withDetails = false, ...props }) {
   const { isOnline, connectionDetails } = useNetworkInfo();
   const [visibility, setVisibility] = React.useState(isOnline ? "hidden" : "offline");
   const wasOnline = React.useRef(isOnline);

   React.useEffect(() => {
      let timeoutId;

      if (!isOnline) {
         setVisibility("offline");
         wasOnline.current = false;
         return;
      }

      if (!wasOnline.current) {
         setVisibility("online");
         timeoutId = setTimeout(
            () => setVisibility("hidden"),
            NETWORK_ONLINE_NOTICE_TIMEOUT,
         );
      }

      wasOnline.current = true;
      return () => clearTimeout(timeoutId);
   }, [isOnline]);

   if (visibility === "hidden") {
      return null;
   }

   const connectionSummary = [
      connectionDetails?.effectiveType,
      Number.isFinite(connectionDetails?.downlink)
         ? `${connectionDetails.downlink} Mbps`
         : null,
      Number.isFinite(connectionDetails?.rtt)
         ? `RTT ${connectionDetails.rtt} ms`
         : null,
   ].filter(Boolean).join(" · ");

   return (
      <div
         className={`network-info network-info--${visibility}`}
         role="status"
         aria-live="polite"
      >
         <div className="network-info__icon" aria-hidden="true">
            {visibility === "offline"
               ? <WifiOff size={19} />
               : <Check size={19} />}
         </div>
         <div className="network-info__content">
            <strong>
               {visibility === "offline"
                  ? "Sem conexão com a internet"
                  : "Conexão restabelecida"}
            </strong>
            {withDetails && connectionSummary && (
               <span className="network-info__details">{connectionSummary}</span>
            )}
         </div>
         {visibility === "online" && (
            <Wifi className="network-info__online-indicator" size={17} aria-hidden="true" />
         )}
      </div>
   );
}